/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Togglemenu1Inputs */

const id_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alihkan menu navigasi`)
};

const ms_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togol menu navigasi`)
};

const da_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift navigationsmenu`)
};

const de_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigationsmenü umschalten`)
};

const en_us2_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle navigation menu`)
};

const es_es2_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú de navegación`)
};

const es_mx2_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú de navegación`)
};

const fil_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-toggle ang navigation menu`)
};

const fr_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu de navigation`)
};

const it_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva menu di navigazione`)
};

const hu_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigációs menü ki/be`)
};

const nl_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigatiemenu in-/uitschakelen`)
};

const no_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slå navigasjonsmeny av/på`)
};

const pl_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przełącz menu nawigacyjne`)
};

const pt_br2_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menu de navegação`)
};

const pt_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar menu de navegação`)
};

const ro_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comutare meniu de navigare`)
};

const fi_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda navigointivalikkoa`)
};

const sv_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Växla navigeringsmeny`)
};

const vi_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển đổi menu điều hướng`)
};

const tr_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezinme menüsünü aç/kapa`)
};

const cs_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepnout navigační menu`)
};

const bg_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превключване на навигационното меню`)
};

const ru_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить меню навигации`)
};

const uk_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити меню навігації`)
};

const ar_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل قائمة التنقل`)
};

const hi_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नेविगेशन मेनू टॉगल करें`)
};

const th_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด/ปิดเมนูนำทาง`)
};

const ja_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ナビゲーションメニューを切り替え`)
};

const zh_cn2_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换导航菜单`)
};

const zh_hant1_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切換導覽選單`)
};

const ko_nav_togglemenu1 = /** @type {(inputs: Nav_Togglemenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탐색 메뉴 열기`)
};

/**
* | output |
* | --- |
* | "Toggle navigation menu" |
*
* @param {Nav_Togglemenu1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_togglemenu1 = /** @type {((inputs?: Nav_Togglemenu1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Togglemenu1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_togglemenu1(inputs)
	if (locale === "ms") return ms_nav_togglemenu1(inputs)
	if (locale === "da") return da_nav_togglemenu1(inputs)
	if (locale === "de") return de_nav_togglemenu1(inputs)
	if (locale === "en-US") return en_us2_nav_togglemenu1(inputs)
	if (locale === "es-ES") return es_es2_nav_togglemenu1(inputs)
	if (locale === "es-MX") return es_mx2_nav_togglemenu1(inputs)
	if (locale === "fil") return fil_nav_togglemenu1(inputs)
	if (locale === "fr") return fr_nav_togglemenu1(inputs)
	if (locale === "it") return it_nav_togglemenu1(inputs)
	if (locale === "hu") return hu_nav_togglemenu1(inputs)
	if (locale === "nl") return nl_nav_togglemenu1(inputs)
	if (locale === "no") return no_nav_togglemenu1(inputs)
	if (locale === "pl") return pl_nav_togglemenu1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_togglemenu1(inputs)
	if (locale === "pt") return pt_nav_togglemenu1(inputs)
	if (locale === "ro") return ro_nav_togglemenu1(inputs)
	if (locale === "fi") return fi_nav_togglemenu1(inputs)
	if (locale === "sv") return sv_nav_togglemenu1(inputs)
	if (locale === "vi") return vi_nav_togglemenu1(inputs)
	if (locale === "tr") return tr_nav_togglemenu1(inputs)
	if (locale === "cs") return cs_nav_togglemenu1(inputs)
	if (locale === "bg") return bg_nav_togglemenu1(inputs)
	if (locale === "ru") return ru_nav_togglemenu1(inputs)
	if (locale === "uk") return uk_nav_togglemenu1(inputs)
	if (locale === "ar") return ar_nav_togglemenu1(inputs)
	if (locale === "hi") return hi_nav_togglemenu1(inputs)
	if (locale === "th") return th_nav_togglemenu1(inputs)
	if (locale === "ja") return ja_nav_togglemenu1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_togglemenu1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_togglemenu1(inputs)
	return ko_nav_togglemenu1(inputs)
});
export { nav_togglemenu1 as "nav.toggleMenu" }